import { Availability, Viewerconfig } from '@3ddv/ngx-sites-builder-lib';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { SblibService } from '../../services/sblib.service';
import { ToolsService } from '../services/tools.service';
//import { Availability } from './models/availability.model';

@Component({
  selector: 'app-sbeditor-tool-availability',
  templateUrl: './availability.component.html',
  styleUrls: ['./availability.component.scss'],
})
export class AvailabilityComponent implements OnInit, OnDestroy {
  public enabled: boolean = false;
  private subscriptions: Array<Subscription>;
  public tool: Availability;
  public postedFile: any;
  public manualAvailability: boolean = false;
  public randomvalue: number = 8;
  private stopandclick$: Subscription;
  public downloadTemplate: SafeUrl;
  private _viewerConfig: Viewerconfig;
  constructor(
    private toolService: ToolsService,
    private sblibService: SblibService,
    private sanitizer: DomSanitizer,
    private toastrService: ToastrService
  ) {
    this.subscriptions = [];
  }

  ngOnInit(): void {
    const tools$ = this.toolService.getAsyncTools$().subscribe(res => {
      if (res.availability) {
        this.tool = res.availability;
      } else {
        console.error('availability tool not found');
        return;
      }
    });
    this.subscriptions.push(tools$);
    // Check if lib is ready
    const sblibReady$ = this.sblibService
      .getSblibReady$()
      .subscribe(libReady => {
        // Check if viewer is ready
        const viewerReady$ = this.sblibService.sblib
          ?.viewerIsReady$()
          .subscribe(viewerReadyConfig => {
            this._viewerConfig = viewerReadyConfig;
            this.generateTemplate();
          });
        this.subscriptions.push(viewerReady$);
      });
    this.subscriptions.push(sblibReady$);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }

  public getTool() {
    return this.tool;
  }

  public onSelectManual() {
    if (this.stopandclick$) this.stopandclick$.unsubscribe();

    if (this.manualAvailability) {
      // Check if lib is ready
      const sblibReady$ = this.sblibService
        .getSblibReady$()
        .subscribe(libReady => {
          // Check if viewer is ready
          const viewerReady$ = this.sblibService.sblib
            ?.viewerIsReady$()
            .subscribe(viewerReady => {
              this.stopandclick$ = this.sblibService.sblib
                .stopandclick$()
                .subscribe(res => {
                  let config = this.sblibService.sblib?.config();
                  console.log(config);
                  if (res.event.nodes.length) {
                    let node = res.event.nodes[0];

                    if (!this.tool.unavailableNodesList)
                      this.tool.unavailableNodesList = {};
                    // init unavailable
                    if (!this.tool.unavailableNodesList[config.venue_id]) {
                      this.tool.unavailableNodesList[config.venue_id] = {
                        seats: [],
                        sections: [],
                        areaprice: [],
                      };
                    }

                    // add / remove items from unavailable
                    if (node.type === 'seat') {
                      let exists = this.tool.unavailableNodesList[
                        config.venue_id
                      ].seats.indexOf(node.id);
                      if (exists > -1) {
                        this.tool.unavailableNodesList[
                          config.venue_id
                        ].seats.splice(exists, 1);
                      } else {
                        this.tool.unavailableNodesList[
                          config.venue_id
                        ].seats.push(node.id);
                      }
                    }
                    if (node.type === 'section' && config.map_id !== node.id) {
                      let exists = this.tool.unavailableNodesList[
                        config.venue_id
                      ].sections.indexOf(node.id);
                      if (exists > -1) {
                        this.tool.unavailableNodesList[
                          config.venue_id
                        ].sections.splice(exists, 1);
                      } else {
                        this.tool.unavailableNodesList[
                          config.venue_id
                        ].sections.push(node.id);
                      }
                    }
                    if (
                      node.type === 'areaprice' &&
                      config.map_id !== node.id
                    ) {
                      let exists = this.tool.unavailableNodesList[
                        config.venue_id
                      ].areaprice.indexOf(node.id);
                      if (exists > -1) {
                        this.tool.unavailableNodesList[
                          config.venue_id
                        ].areaprice.splice(exists, 1);
                      } else {
                        this.tool.unavailableNodesList[
                          config.venue_id
                        ].areaprice.push(node.id);
                      }
                    }

                    //save
                    const tools$ = this.toolService
                      .getAsyncTools$()
                      .subscribe(res => {
                        res.availability = this.tool;
                        this.sblibService.apply(res);
                      });
                    this.subscriptions.push(tools$);
                  }
                });
              this.subscriptions.push(this.stopandclick$);
            });
          this.subscriptions.push(viewerReady$);
        });
      this.subscriptions.push(sblibReady$);
    } else {
      this.sblibService.sblib.runonclick();
    }
  }

  private readFile(file) {
    this.postedFile = file;

    const fileReader = new FileReader();
    fileReader.readAsText(this.postedFile, 'UTF-8');
    fileReader.onload = () => {
      this.tool.unavailableNodesList = JSON.parse(fileReader.result.toString());
    };
  }
  public onFileSelected($event) {
    if (
      ($event.target.files[0].type == '' && $event.target.files[0].size == 0) ||
      $event.target.files[0].type != 'application/json'
    ) {
      this.toastrService.error('', 'Formato del fichero inválido');
      return;
    }
    const file = $event.target.files[0];
    this.readFile(file);
  }

  public onFileDropped($event) {
    this.postedFile = null;
    this.tool.unavailableNodesList = null;

    if (!$event.length) return;

    if (
      ($event[0].type == '' && $event[0].size == 0) ||
      $event[0].type != 'application/json'
    ) {
      this.toastrService.error('', 'Formato del fichero inválido');
      return;
    }

    this.readFile($event[0]);
  }
  private generateTemplate(): void {
    let venue_id = this._viewerConfig.venue_id;
    let template = {
      [venue_id]: {
        sections: [],
        seats: [],
        areaprices: [],
      },
    };

    let data = JSON.stringify(template);
    this.downloadTemplate = this.sanitizer.bypassSecurityTrustUrl(
      'data:text/json;charset=UTF-8,' + encodeURIComponent(data)
    );
  }
  public deleteDroppedFile() {
    this.postedFile = null;
    this.tool.unavailableNodesList = null;
  }

  public cleanAll() {
    this.tool = {
      random: {
        enabled: false,
        value: 0,
      },
      unavailableNodesList: null,
    };
    this.postedFile = null;

    /*     const tools$ = this.toolService.getAsyncTools$().subscribe(res=>{
      res.availability = this.tool;
      this.sblibService.apply(res);
      this.toastrService.success("","Success")
    })
    this.subscriptions.push(tools$); */
  }
  public randomAvailability() {
    this.tool.random.enabled = !this.tool.random.enabled;
    if (this.tool.random.enabled) {
      this.tool.random.value = this.transformReverse(this.randomvalue) * 0.1;
    } else {
      this.tool.random.value = 0;
      this.tool.unavailableNodesList = null;
    }
    const tools$ = this.toolService.getAsyncTools$().subscribe(res => {
      res.availability = this.tool;
      this.sblibService.apply(res);
      this.toastrService.success('', 'Success');
    });
    this.subscriptions.push(tools$);
  }

  public randomUpdate($event) {
    this.tool.random.value = this.transformReverse(this.randomvalue) * 0.1;
    const tools$ = this.toolService.getAsyncTools$().subscribe(res => {
      res.availability = this.tool;
      this.sblibService.apply(res);
      this.toastrService.success('', 'Success');
    });
    this.subscriptions.push(tools$);
  }
  private transformReverse(value) {
    return 10 - value;
  }

  public apply() {
    const tools$ = this.toolService.getAsyncTools$().subscribe(res => {
      res.availability = JSON.parse(JSON.stringify(this.tool));
      this.sblibService.apply(res);
      this.toastrService.success('', 'Success');
    });
    this.subscriptions.push(tools$);
  }
}
